define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi",
	"csi/_base/underscore",
	"csi/api",
	"csi/comm",
	"csi/reflection",
	"csi/store/Nodes",
	"csi/table/Widget",
	"csi/xml",
	"SiteAdmin/Locale"
], function(declare, lang, csi, _, api, comm, reflection, Nodes, Widget, xml, Locale) {

	var FAKE_NODE_TYPE = "_SpecificationOptionalAttributeMap_";
	var PRESENT_ATTR = "Present";
	var MODIFIED_ATTR = "Modified";
	var DISPLAY_ATTR = "DisplayName";

	function _getCustomAttributeUrl(attr) {
		const id = attr.getId();
		let rc = attr.getOwner();

		if (rc.isRevision()) {
			rc = rc.getMasterClass();
		}

		return `centric://REFLECTION/CustomAttribute/${rc.getType()}/${id}`;
	}

	function _watchBooleanAttribute(ac, cn, node, id) {
		node[MODIFIED_ATTR] = true;

		ac.m_writer.changeNode(ac.widget.setupSettingsUrl)
			.changeAttributeKeys(ac.widget.configAttributeId, xml.ATTR_BOOLEANMAP, csi.objectNew(node.$Name, ac.newValue));
	}

	var _Widget = declare([Widget], {

		configNodeType: null,    // override this: Node type which contains optional attributes
		configAttributeId: null, // override this: Attribute Id on the Settings class that contains boolean map

		settingsUrl: null,       // set in this._getRootRequest(): URL of the subtype.Settings instance
		setupSettingsUrl: null,  // set in this._getRootRequest(): URL of the subtype.SetupSettings instance

		onViewStart: function(dfds) {
			dfds.push(Locale.initialize());
			this.inherited(arguments);
		},

		_getRootRequest: function(/* Node */node) {
			this.settingsUrl = node.Settings;
			this.setupSettingsUrl = node.SetupSettings;

			const attributeUrls = this._getAttributes().map(_getCustomAttributeUrl);
			const urls = [this.settingsUrl, this.setupSettingsUrl, ...attributeUrls];

			return comm.getNodeRequest(urls);
		},

		_createQueryLevel: function(/* Object */params, /* Boolean */bRoot) {
			// summary: convert table entries into fake nodes
			var ql = this.inherited(arguments);

			// test for settingsUrl to protect against RequestGenerator use case
			if (ql.bMain && this.settingsUrl) {
				ql.createCustomStore = lang.hitch(this, function() {
					return new Nodes({
						cachingStore: this.cacheView,
						data: this._createRowNodes()
					});
				});
			}
			return ql;
		},

		_createRowNodes: function() {
			// summary: create a fake node for each table row
			var activeMap = this._getActiveMap();
			var setupMap = this._getSetupMap();

			return _.map(this._getAttributes(), function(attr) {
				const id = attr.getId();
				var node = xml.nodeCreateClientNode(null, FAKE_NODE_TYPE, id);
				var activeValue = activeMap[id] || false;
				var setupValue = setupMap[id] || false;
				var attributeNode = this.cacheView.getNode(_getCustomAttributeUrl(attr));

				xml.nodeCreateClientAttr(node, PRESENT_ATTR, xml.ATTR_BOOLEAN, setupValue, activeValue ? xml.ATTR_FLAG_NOEDIT : 0);
				xml.nodeCreateClientAttr(node, DISPLAY_ATTR, xml.ATTR_STRING, attributeNode ? Locale.getConfigurableAttributeNodeName(attributeNode) : id, xml.ATTR_FLAG_NOEDIT);

				// make the row yellow if the setup mapping is different from the published mapping
				xml.nodeCreateClientAttr(node, MODIFIED_ATTR, xml.ATTR_BOOLEAN, setupValue != activeValue);

				return node;
			}, this);
		},

		_getSettings: function() {
			// summary: get the settings that hold the map
			return this.cacheView.getNode(this.settingsUrl);
		},

		_getSetupSettings: function() {
			// summary: get the setup settings that hold the map
			return this.cacheView.getNode(this.setupSettingsUrl);
		},

		_getActiveMap: function() {
			// summary: get the map itself from the settings
			return this._getSettings()[this.configAttributeId];
		},

		_getSetupMap: function() {
			// summary: get the map itself from the setup settings
			return this._getSetupSettings()[this.configAttributeId];
		},

		_getAttributes: function() {
			// summary: return the boolean map of custom Optional attributes
			var rc = reflection.getClass(this.configNodeType);
			var attrs = rc ? rc.getAttributes(true).filter((attr) => attr.isOptional && attr.isCustom) : [];
			return _.sortBy(attrs, (attr) => attr.getId());
		}
	});

	// call this before declaring the derived class
	_Widget.watchBooleanValue = function() {
		// summary: notice when an attribute's mapping changes and add a ChangeNode for it
		api.watchAttribute(FAKE_NODE_TYPE, PRESENT_ATTR, _watchBooleanAttribute);
	};

	return _Widget;
});
